export default __webpack_public_path__ + "static/media/19t.7d4ca5f3.jpg";